import React from "react";
import Timeline from "../../timeline";

function StoryblokTimelineAdapter({ content, title, subtitle }) {
  return <Timeline items={content} title={title} subtitle={subtitle} />;
}

export default StoryblokTimelineAdapter;
